export const daysBR = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SAB"];

export const monthsBR = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

export const ptbr: Locale = {
  localize: {
    ordinalNumber: (...args: any[]) => "",
    era: (...args: any[]) => "",
    quarter: (...args: any[]) => "",
    day: (n: any) => daysBR[n],
    month: (n: any) => monthsBR[n],
    dayPeriod: (...args: any[]) => "",
  },
  formatLong: {
    date: () => "dd/mm/yyyy",
    time: (...args: any[]) => "",
    dateTime: (...args: any[]) => "",
  },
};
